module.exports = __webpack_public_path__ + "img/realtor-logo.ae56783b.svg";